<template>
  <div class="qiluinvoice">
    <div class="qiluinvoicetop">
      <van-nav-bar
        title="开具发票"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <div class="qiluinvoiceimg" style="text-align: center">
      <img src="static/qsbank/img_shenhe_hs_active.png" alt="" />
      <h3 style="margin-top: 30px; color: #888">开具发票说明</h3>
    </div>
    <div class="qiluinvoiceDiv" style="text-align: center">
      <div
        style="
          border-bottom: 1px solid #ccc;
          height: 30px;
          color: #888;
          align-items: center;
          display: flex;
          justify-content: center;
        "
      >
        订单编号：{{ order && order.orderNo }}
        <van-button
          type="info"
          size="mini"
          style="margin-left: 5px"
          class="order-id"
          :data-clipboard-text="order && order.orderNo"
          @click="copyText"
          >复制</van-button
        >
      </div>
    </div>
    <div class="qiluinvoiceText">
      <div>
        1、尊敬的客户，如果您需要开具发票，请您在上传图片成功后，通过邮件方式提出开票申请，没有提交申请视为放弃开票需求。
      </div>
      <div>2、您的电子普通发票将由恒宝股份有限公司开具。</div>
      <div>
        3、因为您的卡面定制服务是以个人名义申请，电子发票只能以您的姓名或‘个人’名义开具，请将您的姓名和订单编号一起发送到邮箱：zhaojian@hengbao.com。
      </div>
      <div>
        4、我们将在照片审核通过后10个工作日为您开具电子普通发票，收件人地址是您提交申请的邮箱地址，请注意查收。
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  data() {
    return {
      order: null, //当前订单
      isReuploadPayed: false //审核未通过重新上传卡面方式 true 其他方式false
    };
  },
  mounted: function () {
    console.log("this.$route.params :>> ", this.$route.params);
    var result = this.$route.params.data;
    this.order = result;
    this.isReuploadPayed = result.isReuploadPayed;
    console.log("isReuploadPayed->" + this.isReuploadPayed);
    let count = this.$store.state.qs.reuploadCount;
    console.log("reuploadCount:" + count);
    let entrance = sessionStorage.getItem("entrance");
    console.log("entrance:" + entrance);
    let storeStr = JSON.stringify(this.$store.state.qs);
    console.log(storeStr);
  },
  //vue销毁页面执行
  destroyed: function () {
    this.toHomqs();
  },
  methods: {
    toHomqs: function () {
      let entrance = sessionStorage.getItem("entrance");
      let count = this.$store.state.qs.reuploadCount;
      console.log(`entrance`, entrance);
      console.log(`count`, count);
      let isReupload = count > 0;
      console.log("isReupload->" + isReupload)
      if (entrance == 1) {
        // 申请卡面入口
        if (isReupload) {
          let backCount = ((count * 2)- 1) + 1;
          console.log("backCount:" + backCount);
          this.$router.go(-backCount);
        } else {
          //申请
          //this.$router.go(-1);
        }
      } else if (entrance == 2) {
        //查询进度入口
        if (isReupload) {
          //订单未支付，重新上传卡面回退
          let backCount = ((count * 2) - 1) + 1;
          console.log("backCount:" + backCount);
          this.$router.go(-backCount);
        } else {
          if (this.isReuploadPayed === true) {
            //审核未通过，重新上传页面回退
            let backCount = ((count * 2) - 1) + 2;
            console.log("backCount:" + backCount);
            this.$router.go(-backCount);
          } else {

          }
        }
      } else {
      }
    },
    //返回按钮
    onClickLeft() {
      this.$router.go(-1);
    },
    //复制
    copyText() {
      var clipboard = new Clipboard(".order-id"); //绑定数据标签的类名
      clipboard.on("success", (e) => {
        this.$toast({
          message: "复制成功",
          position: "top",
        });
        // this.$notify({ type: "success", message: "复制成功" });
        // console.log("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$toast({
          message: "该浏览器或手机权限不支持复制功能",
          position: "top",
        });
        // this.$notify({ type: 'success', message: '该浏览器或手机权限不支持复制功能' });
        // console.log("该浏览器或手机权限不支持复制功能");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style scoped lang="less">
.qiluinvoice {
  width: 100%;
  height: 100%;
  .qiluinvoiceimg {
    text-align: center;
    width: 100%;
    height: 200px;
    padding-top: 50px;
  }
  .qiluinvoiceDiv {
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }
  .qiluinvoiceText {
    width: 100%;
    margin-top: 30px;
    padding: 0 20px;
    div {
      margin-top: 5px;
      font-size: 14px;
      color: #888888;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/qishangbank/Invoicesq_qs.vue